<template>
  <div class="d-flex p-20 justify-content-center">

    <div class="welcome-card">
      <div>
        <img
            alt="Landing image"
            class="img-fluid"
            src="./../assets/images/landing-img@2x.png"
            srcset="
                    ./../assets/images/landing-img@1x.png 1x,
                    ./../assets/images/landing-img@2x.png 2x,
                    ./../assets/images/landing-img@3x.png 3x,
                    ./../assets/images/landing-img@4x.png 4x
                "
        />
      </div>
      <div class="welcome-card-item">
        <div>
          <h1>{{ 'AI Creator Studio' | trans }}</h1>
          <p>{{ 'Choose from various artistic styles, use the prompt editor for inspiration, and discover our advanced settings.Watch as our advanced AI generates stunning images, bringing your creativity to life!' | trans}}</p>
        </div>
      </div>
      <div class="welcome-card-item">
        <div class="welcome-card-icon">
          <i class="far fa-2x fa-style"></i>
        </div>
        <div class="welcome-card-content">
          <h2>
            {{ 'Choose a Style' | trans }}
          </h2>
          <p>{{ 'With our advanced AI technology, you can now transform your images into captivating works of art by choosing from a wide range of artistic styles. Whether you prefer classic oil paintings, abstract masterpieces, or modern digital art, our AI-powered style transfer feature can seamlessly apply the chosen style to your images, giving them a unique and eye-catching appearance.' | trans}}</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import store from './../mixins/store.mixin'

export default {
  name: "Welcome",
  props: {},
  components: {},
  mixins: [
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
.welcome-card {
  width: 685px;
  background: #424242;
  color: #E8EAED;
}

.welcome-card-item {
  border-bottom: 1px solid #595959;
  padding: 20px;
  display: flex;
  gap: 20px;

  // .welcome-card-icon {
  // }

  // .welcome-card-content {
  // }

  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #E8EAED;
  }

  h2 {
    font-size: 17.5px;
    font-weight: 600;
    margin: 0 0 10px 0;
    color: #E8EAED;
  }

  p {
    font-size: 14px;
    font-weight: 400;
  }
}

</style>
